import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useDataCache } from '../contexts/DataCacheContext';

const ProtectedRoute = ({ children, skipRedirect = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const { cache } = useDataCache();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh'
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Skip all redirect logic if skipRedirect is true (for subscription-complete page)
  if (skipRedirect) {
    return children;
  }

  // Check subscription status from cache if available, otherwise check JWT
  const subscriptionStatus = cache.plans?.subscriptionStatus;
  const jwtStatus = user?.attributes?.['custom:subscription_status'];
  
  const hasActivePayment = 
    subscriptionStatus?.status === 'active' || 
    subscriptionStatus?.status === 'trialing' || 
    subscriptionStatus?.payment_type === 'prepaid' ||
    jwtStatus === 'active' ||
    jwtStatus === 'trialing';
  
  if (!hasActivePayment && location.pathname !== '/plans') {
    console.log('🔒 PROTECTED ROUTE: No active subscription/prepaid, redirecting to plans');
    return <Navigate to="/plans" replace />;
  }

  return children;
};

export default ProtectedRoute;